/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/vehicle/vehicle_interfaces.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class ManageVehicleModelsDirectiveController {
        public static $inject: string[] = [
            '$mdDialog',
            '$mdMedia',
            '$mdEditDialog',
            '$scope',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'DealerwareTrimCollection'
        ];

        private _order: string;

        public trims: any;
        public availableModelYears: any[];
        public onClose: any;
        public loader: any;

        constructor(public $mdDialog: any,
                    public $mdMedia: any,
                    public $mdEditDialog: any,
                    public $scope: any,
                    public auth: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public DealerwareTrimCollection: any) {
            var currentYear = moment().year();

            this.availableModelYears = [];

            this.$scope.$watch(() => {
                return this.trims
            }, (trims: any) => {
                if (trims && trims.data.length > 0 && this.availableModelYears.length === 0) {
                    var startYear = Math.min(...(trims.data.map((t: any) => { return t.data.year })));

                    for (var y = currentYear + 1; y >= startYear; y--) {
                        this.availableModelYears.push(y);
                    }
                }
            });
        }

        public get order() : string {
            return this._order;
        }

        public set order(order: string) {
            var _self = this;

            this._order = order;
            if (order) {
                var sortDirection = order.indexOf('-') === 0 ? 'desc' : 'asc',
                    sortBy = order.replace('-', '');

                var loader = this.$dealerwareLoading.show('Loading...');
                this.DealerwareTrimCollection.index({
                    promise: true,
                    params: {
                        location_id: this.auth.location.id,
                        sort_by: sortBy,
                        sort_direction: sortDirection
                    }
                }).then(
                    function(returnValue: any) { _self.trims = returnValue },
                    function(response: any) { _self.$dealerwareNotification.apiError(response); }
                ).finally(function() {
                    loader.close();
                });
            }
        }

        public showCreateModal() : void {
            var _self = this;

            this.$mdDialog.show({
                controller: dialogController,
                templateUrl: '/components/vehicle/models/create_vehicle_model_dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: this.$mdMedia('xs') || this.$mdMedia('sm'),
                locals: {
                    location: this.auth.location,
                    availableModelYears: this.availableModelYears
                }
            });

            function dialogController($scope: any, $mdDialog: any, DealerwareTrimModel: any, location: any, availableModelYears: any) {
                $scope.trim = new DealerwareTrimModel();
                $scope.availableModelYears = availableModelYears;
                $scope.location = location;

                $scope.save = function() {
                    var loader = _self.$dealerwareLoading.show('Saving...');
                    $scope.trim.$create({
                        promise: true,
                        params: { location_id: $scope.location.id }
                    }).then(
                        function(returnValue: any) {
                            $scope.close();
                            _self.trims.data.push(returnValue);
                        },
                        function(response: any) { _self.$dealerwareNotification.apiError(response); }
                    ).finally(function() { loader.close(); });
                };

                $scope.close = function() {
                    $mdDialog.hide();
                };
            };
        }

        public editTrimAttribute(event: any, trim: any, attribute: string, label: string) : void {
            var _self = this;

            event.stopPropagation();

            this.$mdEditDialog.large({
                modelValue: trim.data[attribute],
                title: label,
                placeholder: label,
                save: function(input: any) {
                    trim.data[attribute] = input.$modelValue;
                    _self.saveTrim(trim);
                },
                targetEvent: event
            });
        }

        public saveTrim(trim: any) {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');
            trim.$update({
                promise: true,
                params: { location_id: this.auth.location.id }
            }).then(undefined, function(response: any) {
                trim.resetData();
                _self.$dealerwareNotification.apiError(response);
            }).finally(function() { loader.close(); });
        }

        public close() : void {
            if (this.onClose && angular.isFunction(this.onClose)) {
                this.onClose();
            }
        }
    }

    getDealerwareWebComponentsModule().controller('ManageVehicleModelsDirectiveController', ManageVehicleModelsDirectiveController);

    export class ManageVehicleModelsDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ManageVehicleModelsDirectiveController';
        public controllerAs     : string    =   'manageModelsController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            trims: '=',
            onClose: '&'
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/vehicle/models/manage_vehicle_models_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope: ng.IScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            ctrls: any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareManageVehicleModels",() => new ManageVehicleModelsDirective());
}
